import { PostHogAnalytics } from "@/components/analytics/PostHogAnalytics";
import { Skeleton } from "@/components/ui/skeleton";
import { Spinner } from "@/components/ui/spinner";
import { useSession } from "@/hooks/useSession";
import { AppRouter } from "@/lib/router";
import { Ship } from "lucide-react";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

export function App() {
  const session = useSession();

  if (session.loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-muted/40 p-4">
        <div className="flex flex-col items-center gap-4">
          <div className="grid size-12 place-items-center rounded-xl bg-primary text-primary-foreground shadow-md">
            <Ship className="size-6" />
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <Spinner size="sm" />
            <span className="text-sm font-medium">Loading ShipPeek...</span>
          </div>
          <div className="w-64 space-y-2">
            <Skeleton className="h-2 w-full" />
            <Skeleton className="h-2 w-3/4" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <PostHogAnalytics connected={session.connected} user={session.user} />
      <AppRouter connected={session.connected} />
    </BrowserRouter>
  );
}
